import * as ActionConfigurationManager from './config.actions';

export const submitVertexTax = ActionConfigurationManager.SUBMIT_VERTEX_TAX;
export const vertexTaxSubmitted = ActionConfigurationManager.VERTEX_TAX_SUBMITTED;
export const compareTaxes = ActionConfigurationManager.COMPARE_TAXES
export const taxesCompared = ActionConfigurationManager.TAXES_COMPARED
